import {
  Component,
  forwardRef,
  Injector,
  Input
} from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInputComponent } from '../base-input.directive';

@Component({
  selector: 'fpc-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true,
    }
  ]
})
export class InputTextComponent extends BaseInputComponent {

  @Input() labelColor!: string;
  @Input() labelClass = 'mb-2';
  @Input() iconSize: string;
  @Input() inputClass: string = 'h4';

  constructor(injector: Injector) {
    super(injector);
  }
}
